"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = _interopRequireDefault(require("./colors"));

var _fontWeight = _interopRequireDefault(require("./fontWeight"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var formLabels = {
  color: _colors["default"].monochrome6["default"],
  weight: _fontWeight["default"][2],
  state: {
    success: {
      color: _colors["default"].monochrome6["default"],
      weight: _fontWeight["default"][2]
    },
    info: {
      color: _colors["default"].monochrome6["default"],
      weight: _fontWeight["default"][2]
    },
    warn: {
      color: _colors["default"].monochrome6["default"],
      weight: _fontWeight["default"][2]
    },
    error: {
      color: _colors["default"].error["default"],
      weight: _fontWeight["default"][2]
    },
    disabled: {
      color: _colors["default"].monochrome6.disabled,
      weight: _fontWeight["default"][2]
    }
  },
  inverse: {
    color: _colors["default"].monochrome6["default"],
    weight: _fontWeight["default"][2],
    state: {
      success: {
        color: _colors["default"].monochrome6["default"],
        weight: _fontWeight["default"][2]
      },
      info: {
        color: _colors["default"].monochrome6["default"],
        weight: _fontWeight["default"][2]
      },
      warn: {
        color: _colors["default"].monochrome6["default"],
        weight: _fontWeight["default"][2]
      },
      error: {
        color: _colors["default"].error["default"],
        weight: _fontWeight["default"][2]
      },
      disabled: {
        color: _colors["default"].monochrome6.disabled,
        weight: _fontWeight["default"][2]
      }
    }
  }
};
var _default = formLabels;
exports["default"] = _default;
//# sourceMappingURL=formLabels.js.map